__turbopack_context__.v({
  "emptyMsg": "accordion-filter-module-scss-module__rE1Xiq__emptyMsg",
  "inner": "accordion-filter-module-scss-module__rE1Xiq__inner",
  "root": "accordion-filter-module-scss-module__rE1Xiq__root",
});
